import React, {FC} from 'react';
import './style.scss';
import {pathSuite} from "../../../constants";
import {useHistory} from 'react-router-dom';

interface ICompilationsCard {
    title: string,
    description: string,
    imageUrl: string,
    id: number,
    fetchMixCompilation: any,
    setCurrentCompilations: any
}

const CompilationsCard: FC<ICompilationsCard> = ({
                                                     title,
                                                     description,
                                                     imageUrl,
                                                     id,
                                                     fetchMixCompilation,
                                                     setCurrentCompilations
                                                 }) => {

    const history = useHistory();
    const clickHandler = (id: number) => {
        setCurrentCompilations(id);
        fetchMixCompilation(id);
        history.push(`/main/compilation/${id}`)
    };

    return (
        <div className="compilations__card"
             style={{backgroundImage: ` url(${pathSuite + imageUrl})`}}
             onClick={() => clickHandler(id)}
        >
            <div className="compilations__card-container">
                <div className="compilations__card-title">
                    {title}
                </div>
                <div className="compilations__card-description">
                    {description}
                </div>
            </div>
        </div>
    )
};

export default CompilationsCard;
